import { render, staticRenderFns } from "./Valid.vue?vue&type=template&id=65f88539&scoped=true&"
import script from "./Valid.vue?vue&type=script&lang=js&"
export * from "./Valid.vue?vue&type=script&lang=js&"
import style0 from "./Valid.vue?vue&type=style&index=0&id=65f88539&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65f88539",
  null
  
)

export default component.exports